<template>
  <nuxt-link
    class="notification-panel__notification-link"
    :to="route"
    @click="markAsReadAndHandleClick"
  >
    <div class="notification-panel__notification-content-title">
      <i18n-t keypath="clientRatingReceivedNotification.title" tag="span">
        <template #contact>
          <strong>{{
            notification.data.contact_name ||
            $t('clientRatingReceivedNotification.someone')
          }}</strong>
        </template>
        <template #title>
          <strong>{{ notification.data.title }}</strong>
        </template>
        <template #score>
          <strong>{{ notification.data.score }}/10</strong>
        </template>
      </i18n-t>
    </div>
    <div
      v-if="notification.data.comment"
      class="notification-panel__notification-content-desc"
    >
      “{{ notification.data.comment }}”
    </div>
  </nuxt-link>
</template>

<script>
import notificationContent from '@baserow/modules/core/mixins/notificationContent'

export default {
  name: 'ClientRatingReceivedNotification',
  mixins: [notificationContent],
  emits: ['close-panel'],
  methods: {
    handleClick() {
      this.$emit('close-panel')
    },
  },
}
</script>
